import { render, staticRenderFns } from "./CredentialsSettingsSectionHeader.vue?vue&type=template&id=5b393e55&scoped=true&"
import script from "./CredentialsSettingsSectionHeader.vue?vue&type=script&lang=js&"
export * from "./CredentialsSettingsSectionHeader.vue?vue&type=script&lang=js&"
import style0 from "./CredentialsSettingsSectionHeader.vue?vue&type=style&index=0&id=5b393e55&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b393e55",
  null
  
)

export default component.exports